module.exports = __webpack_public_path__ + "9153320d009f19d50128afa6f956b471.svg";